export default {
      id: "drag-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#drag-usage",
      toString: function () {
        return this.url;
      }
    }